enum PokemonActionType {
  loadPokemon,
  unknownAction,
  loadDetailedPokemon,
  loadFavouritePokemon,
  deleteFavouritePokemon,
}

export default PokemonActionType;
